import createElement, { createCommentNode } from '../vdom/create-element'
import { $, clone, noop } from './'
import patch from '../vdom/patch'
import h from '../vdom/h'

interface VueInstanceLifeHooks {
  created (): any
}

interface VueOptions {
  el: string | HTMLElement
  data?: any
  methods?: any
  render (h: any): any
  [index: string]: any
}

export default class Vue {
  public $el: HTMLElement
  public $options: VueInstanceLifeHooks
  private _data: any
  private _vnode: any
  private _uid: number
  private _render (h: any): any {}

  static _ = {}

  constructor (options: VueOptions) {
    const { el = '', data = {}, methods = {}, render, created = noop } = options

    Vue._ = clone(data)

    this._data = data
    this.$el = $(el)
    this._render = render
    this.$options = { created }

    for (let event in methods) this[event] = methods[event].bind(this)

    this.observe()
    this.render()
  }

  public observe () {
    const { _data: data } = this

    for (let key in data) {
      Object.defineProperty(this, key, {
        get () { return data[key] },
        set: val => {
          data[key] = val
          this.patch()
        }
      })
    }
  }

  public patch () {
    const vnode = this._render(h)
    patch(this._vnode, vnode, this.$el)
    this._vnode = vnode
  }

  public render () {
    const vnode = this._render(h)
    const element = !vnode ? createCommentNode() : createElement(vnode, this)
    const { $el } = this
    document.body.replaceChild(element, $el)
    this.$el = element
    this._vnode = vnode

    if (vnode) {
      const cloned = clone(Vue._)
      for (let key in cloned) this[key] = cloned[key]
      this.$options.created.call(this)
    }
  }
}
